<template>
  <div class="warning-about-index">
    <van-sticky>
      <headerItem titleName="工单详情" :showUp="false" :showRight="true" />
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" :head-height="80" success-text="刷新成功">
    <div class="warning-about-container">
      <div class="warning-about-item">
        <div class="title">预警状态：{{formData.warningStatus==1?'待处理':formData.warningStatus==2?'处理中':'已完成'}}</div>
        <div class="content">
          <van-steps direction="vertical" :active="0" active-color="#ED3939">
            <van-step v-for="(item,index) in detailsList" :key="index">
              <div class="header-title">
                <p class="left" :style="{'color':item.warningLevel==1?'#F8D541':item.warningLevel==2?'#F8A651':'#ED3939'}">{{item.warningLevel}}级预警</p>
                <p class="right">{{item.warningSource}}</p>
              </div>
              <p class="info">{{item.content}}</p>
              <p class="time">{{item.gmtCreated}}</p>
            </van-step>
          </van-steps>
        </div>
      </div>
    </div>
    </van-pull-refresh>
    <van-goods-action class="footer"  v-if="formData.warningStatus==1">
      <van-button :color="$theme.main_color_btn_bg" round @click="clickJumpFun"> 立即处理</van-button>
    </van-goods-action>
    <div  v-if="formData.warningStatus==1 && warningId ">
      <modalItem :show="show" @closeModalFun="closeModal" :warningDeatils="formData" :jumpDetals="formData.warningDetails[0].jump"/>
    </div>
    
  </div>
</template>

<script>
import headerItem from "./components/header";
import modalItem from './components/modalItem';
import utils from "@/utils/common";
export default {
  data() {
    return {
      show:false,
      detailsList:[],
      warningId:'',
      refreshing: false,
      formData:{}
    };
  },
  methods: {
    showModal(){
      this.show=!this.show;
    },
    clickJumpFun() {
      this.showModal();
      // if (this.formData.warningDetails[0] && this.formData.warningDetails[0].jump) {
      //   if(this.formData.businessType ==2){
      //     this.jumpAfterDeatils();
      //   }else if(this.formData.businessType ==1){
      //     this.jumpsubOrderDeatils();
      //   }else if(this.formData.businessType ==3){
      //     this.$toast('im')
      //   }
        
      // } else {
      //   this.showModal();
      // }
    },
    closeModal(item){
      this.showModal();
      if(item){
        this.$router.go(-1);
      }
    },
    jumpsubOrderDeatils(){
      if (this.formData.businessId) {
        utils.jumpToNewPage({
          url:window.location.origin +"/h5user/beesOrderDetail?subId=" +this.formData.businessId,
          noTitle: "0",
        });
      }
    },
    jumpAfterDeatils() {
      if (this.formData.businessId) {
        utils.jumpToNewPage({
          url:
            window.location.origin +
            "/h5user/beeafterorderDetail?afterId=" +
            this.formData.businessId,
          noTitle: "0",
        });
      }
    },
    init(){
      let id = this.$route.query.id ;
      this.warningId = id;
      this.http({
        url: "/order/manage/warning/app/details?id="+id,
        method: "get",
        parmes: {
          id: id,
        },
      }).then(rps=>{
        if(rps.code==200){
          this.formData = rps.data;
          this.detailsList = rps.data.warningDetails;
          this.finished = true;
        }
      }).catch(err=>{
        this.finished = true;
      })
    },
    onRefresh() {
      this.refreshing = false;
      this.init();
    },
  },
  components: {
    headerItem,
    modalItem
  },
  created() {
    this.$loading.hide();
    this.init();
  },
};
</script>

<style lang="less" scoped>
.warning-about-index {
  font-size: 24px;
  .warning-about-container {
    padding: 20px;
    padding-bottom: 120px;
  }
  .warning-about-item {
    background-color: #fff;
    .title {
      border-bottom: 2px solid #f2f2f2;
      padding: 26px 30px;
      font-size: 24px;
      color: #333;
    }
    .content {
      padding: 26px 30px;
      .info {
        font-size: 20px;
        color: #999;
        padding: 5px 0;
      }
      .time {
        font-size: 20px;
        color: #666;
      }
      .header-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          font-size: 26px;
        }
        .right {
          font-size: 22px;
          color: #666;
          font-weight: 500;
        }
      }
    }
  }
  .footer {
    justify-content: center;
    .van-button {
      width: 90%;
      height: 76px;
      color: var(--epTextColor) !important;
      font-weight: 500;
    }
  }
}
</style>